var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusEmplLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25586 0.0449219C3.79682 0.0449219 0.982422 2.85932 0.982422 6.31836C0.982422 9.7774 3.79682 12.5918 7.25586 12.5918C10.7149 12.5918 13.5293 9.7774 13.5293 6.31836C13.5293 2.85932 10.7149 0.0449219 7.25586 0.0449219ZM10.7621 4.66745L6.75273 8.64535C6.51688 8.88119 6.13953 8.89691 5.88797 8.66107L3.76538 6.72716C3.51381 6.49131 3.49809 6.09824 3.71821 5.84667C3.95405 5.59511 4.34712 5.57938 4.59869 5.81523L6.28104 7.35607L9.86586 3.77125C10.1174 3.51968 10.5105 3.51968 10.7621 3.77125C11.0136 4.02282 11.0136 4.41589 10.7621 4.66745Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusEmplLogo);
export default __webpack_public_path__ + "static/media/status_empl_logo.0432f0d12d304f07c90ce756093d01f4.svg";
export { ForwardRef as ReactComponent };